import { Grid } from "@mui/material";
import TopicPieChartWrapper from "./TopicPieChartWrapper";
import TopicStackedChartWrapper from "./TopicStackedChartWrapper";
import { PageHeader } from "../../../components/PageHeader";
import { useTranslation } from "react-i18next";

function TopicPage() {
  const { t } = useTranslation(["common", "topic"]);
  return (
    <Grid container>
      <PageHeader text={t("topic:topic_basic_stats")}></PageHeader>
      <Grid item xs={0.75}></Grid>
      <Grid item xs={3.5} className="grid-border white slide-from-left">
        <TopicPieChartWrapper />
      </Grid>
      <Grid item xs={0.25}></Grid>
      <Grid item xs={7} className="grid-border white slide-from-right">
        <TopicStackedChartWrapper day={15} />
      </Grid>
      <Grid item xs={0.5}></Grid>
    </Grid>
  );
}
export default TopicPage;
